import { render, staticRenderFns } from "./sourceGoods.vue?vue&type=template&id=aaf31840"
import script from "./sourceGoods.vue?vue&type=script&lang=js"
export * from "./sourceGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports